<div class="pageHeader">
    <h1 class="pageHeading" style="margin-bottom: 32px; margin-top: 88px; text-align: center;">Eqaro Guarantees <span style=" color: #828282;"> & </span> YourOwnROOM</h1>
    <div class="row " style="padding: 32px 40px">
        
        <div class="col-md-6 col-12 header">
            
            <div>
                <p class="contentSubText">Eqaro Guarantees will issue rental bonds on behalf of the YourOwnROOM’s tenants at a nominal fee to the landlord. This will enable the tenants to move into rented apartments without any security deposit. This initiative between Eqaro & YourOwnROOM aims to make available zero deposit rooms to the entire tenant community including families, working professionals and singles. </p>
                <p class="contentSubText">The customised offering is extremely wide in its coverage which includes covers for unpaid rent, lock-in period up to 11 months, damages to the property, utility bills payment, move-out charges, and breach of notice period. YourOwnROOM are a trusted custodian of residential assets for homeowners and offer multiyear rental & property management services to landlords. It signs a 3-5 year MoU with property owners to manage their property and rentals. The proposition benefits the landlords as well. Eqaro Guarantees will provide landlords with credit verified and assessed tenants backed by an institutional guarantee.</p>
            </div>
        </div>
        <div class="col-md-6 col-12" style="margin-bottom: 24px;">
            <img src="../../../assets/images/eqaro_bg.jpg" class="img-responsive" style="width: 100%;"/>
        </div>
    </div>
</div>

<div class="pageWrapper" style="margin: 32px 0px; ">
    <div class="row contentDespWrapper">
        <div class="col-md-3 col-12">
            <p class="sectionHeader" style="font-weight: 600; margin-top: 8px; margin-bottom: 24px;">Rental Bonds</p>
        </div>
        <div class="col-md-9 col-12">
            <p class="contentSubText">Eqaro Rental Bonds offer a transformative solution for both landlords and tenants, revolutionizing the residential rental market by imparting trust between the landlord & the tenant and streamlining the process of renting a home. These bonds create a win-win situation, ensuring that landlords have reliable and creditworthy tenants while empowering tenants to move into their dream homes without the burden of a hefty deposit and the hassle of numerous follow up for refund from the landlords.</p>
        </div>
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        <div class="col-md-2 col-12">
                <div  style="margin-bottom: 16px; ">
                    <img src="../../../assets/images/eqaro_pankaj.jpeg" style="width: 196px; height: 196px;">
                </div>
        </div>
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “This alliance will make aspirational housing accessible to prospective tenants without the need for security deposit. Rental Bonds are superior to the traditional cash security deposits and provide the landlords with credit verified and assessed tenants. For the first time in India, the tenants will now have the opportunity of carrying forward the benefits of a good tenancy track record to their subsequent tenancies.”<br> - Pankaj Bhansali, COO & CBO, Eqaro Guarantees.
            </div>
        </div>
        
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “Our key aim is to optimize the currently available real estate inventory and deliver an experience and value to the tenants. We aim to deliver ready-to-move-in rooms for singles with zero deposits and no hassles. Our ready-to-move-in rooms and houses reduce the cost of moving into a new accommodation to nearly zero.” <br> - Prabhat Kumar Tiwary, Founder, MD& CEO, YourOwnROOM.
            </div>
        </div>
        <div class="col-md-2 col-12">
            <div  style="margin-bottom: 16px; ">
                <img src="../../../assets/images/prabhat_latest.jpeg" style="width: 196px; height: 196px;">
            </div>
    </div>
    </div>
   
</div>

